import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

/**
 * Component that updates the document title
 * @param {Object} props - Component props
 * @param {string} props.title - The page title to set
 * @param {React.ReactNode} props.children - Optional children components
 */
function PageTitle({ title, children }) {
  useEffect(() => {
    // Base title for the application
    const BASE_TITLE = 'VirtualPAT';

    if (title) {
      document.title = `${title} | ${BASE_TITLE}`;
    } else {
      document.title = BASE_TITLE;
    }

    return () => {
      // Reset title on unmount if needed
      document.title = BASE_TITLE;
    };
  }, [title]);

  // This component doesn't render anything visible
  return children || null;
}

PageTitle.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default PageTitle;
